import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Numbers.scss";
import { FormikProps } from "formik";
import { NumericFormat } from 'react-number-format';

interface InputNumberProps {
  label: string;
  name: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  value: any;
  formik: FormikProps<MyFormValues>;
}

interface MyFormValues {
  negotiationName: string;
  leadCountry: string;
  categoryName: string;
  categoryCode: string;
  cluster: string;
  negotiationTeam: string;
  od: string;
  suppliers: string;
  supplierLocation: string;
  salesRepLead: string;
  additionalSalesRep: string;
  negotiationDateMonth: string;
  negotiationDateYear: string;
  negotiationImplementationMonth: string;
  negotiationImplementationYear: string;
  validityPeriod: number;
  relevantSpend: number;
  comment: string;
}
const InputNumber = ({
  label,
  value,
  name,
  onBlur,
  touched,
  error,
  formik,
}: InputNumberProps) => {
  return (
    <div className="numeric-input-wrapper">
      <label className="numeric-input-label">{label}</label>
      <div className="numeric-input-custom">
        <NumericFormat
          className="form-control"
          name={name}
          value={value}
          onValueChange={(values: any) => {
            formik.setFieldValue(name, values.value); 
          }}
          thousandSeparator={true}
          decimalScale={2}
          allowNegative={false}
          onBlur={onBlur}
        />
        <span className="numeric-icon"></span>
      </div>
      {touched && error && <div className="error-text">{error}</div>}
    </div>
  );
};
export default InputNumber;